import { render, staticRenderFns } from "./ForecastFlowRuglTable.vue?vue&type=template&id=4fdfddce&scoped=true"
import script from "./ForecastFlowRuglTable.vue?vue&type=script&lang=js"
export * from "./ForecastFlowRuglTable.vue?vue&type=script&lang=js"
import style0 from "./ForecastFlowRuglTable.vue?vue&type=style&index=0&id=4fdfddce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdfddce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VRow})
